import { Download, FileText } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

interface Props {
  filename: string;
  mimeType: string;
  contentBase64: string;
  sizeBytes: number;
}

function downloadBase64(
  filename: string,
  mimeType: string,
  base64: string,
): void {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  const blob = new Blob([bytes], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/** Relatorio gerado (PDF) entregue inline -- download via Blob. */
export function ReportDownloadBlock({
  filename,
  mimeType,
  contentBase64,
  sizeBytes,
}: Props) {
  const { t } = useTranslation("observabilityAgent");
  const kb = Math.max(1, Math.round(sizeBytes / 1024));
  return (
    <div className="bg-card my-2 flex items-center gap-3 rounded-md border p-3 text-sm">
      <FileText className="text-brand-500 h-5 w-5 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="truncate font-medium">{filename}</p>
        <p className="text-muted-foreground text-xs">{kb} KB</p>
      </div>
      <Button
        size="sm"
        onClick={() => downloadBase64(filename, mimeType, contentBase64)}
      >
        <Download className="h-4 w-4" />
        {t("download")}
      </Button>
    </div>
  );
}
